import * as types from './types';
import Vue from 'vue';
import api from '@/api/signatory';
import store from '@/store';

export default {
  createSignatory({ commit }, params) {
    store.dispatch('application/startLoading');
    return api.createSignatory(params)
      .then((response) => {
        if (response.status === 'success') {
          store.dispatch('application/displaySnackbar', {
            text: Vue.$i18n.t('store.signatory.create.success'),
            time: 3,
            type: 'success',
          });
          return Promise.resolve(response);
        } else {
          return Promise.reject(response);
        }
      })
      .catch((error) => {
        if (!params.muteError) {
          store.dispatch('application/displaySnackbar', {
            text: `${Vue.$i18n.t('store.signatory.create.error')} <br> ${error.data.message}`,
            time: 5,
            type: 'error',
          });
        }
        return Promise.reject(error);
      })
      .finally(() => {
        store.dispatch('application/finishLoading');
      });
  },
  updateSignatory({ commit }, params) {
    store.dispatch('application/startLoading');
    return api.updateSignatory(params)
      .then((response) => {
        console.log(response);
        if (response.status === 'success') {
          store.dispatch('application/displaySnackbar', {
            text: Vue.$i18n.t('store.signatory.update.success'),
            time: 3,
            type: 'success',
          });
          return Promise.resolve(response);
        } else {
          return Promise.reject(response);
        }
      })
      .catch((error) => {
        store.dispatch('application/displaySnackbar', {
          text: Vue.$i18n.t('store.signatory.update.error'),
          time: 3,
          type: 'error',
        });
        return Promise.reject(error);
      })
      .finally(() => {
        store.dispatch('application/finishLoading');
      });
  },
  deleteSignatory({ commit }, searchParams) {
    // loader
    store.dispatch('application/startLoading');
    return api.deleteSignatory(searchParams)
      .then((response) => {
        if (response.status === 'success') {
          store.dispatch('application/displaySnackbar', {
            text: Vue.$i18n.t('store.signatory.delete.success'),
            time: 3,
            type: 'success',
          });
          return Promise.resolve(response.data);
        }
        return Promise.reject(response);
      })
      .catch((error) => {
        store.dispatch('application/displaySnackbar', {
          text: Vue.$i18n.t('store.signatory.delete.error'),
          time: 3,
          type: 'error',
        });
        return Promise.reject(error);
      })
      .finally(() => {
        store.dispatch('application/finishLoading');
      });
  },
  getSignatory({ commit }, signatoryId) {
    store.dispatch('application/startLoading');
    return api.getSignatory(signatoryId)
      .then((response) => {
        if (response.status === 'success') {
          return Promise.resolve(response.data.account);
        }
        return Promise.reject(response);
      })
      .catch((error) => {
        store.dispatch('application/displaySnackbar', {
          text: Vue.$i18n.t('store.signatory.get.error'),
          time: 3,
          type: 'error',
        });
        return Promise.reject(error);
      })
      .finally(() => {
        store.dispatch('application/finishLoading');
      });
  },
  getSignatoryLogo({ commit }, searchParams) {
    return api.getSignatory(searchParams)
      .then((response) => {
        if (response.status === 'success') {
          return Promise.resolve(response.data.account.logo);
        }
        return Promise.reject(response);
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  },
  getSignatories({ commit }, searchParams) {
    // loader
    store.dispatch('application/startLoading');
    // save search params
    commit(types.SET_SIGNATORY_SEARCH_PARAMS, searchParams);
    // parse such params for request
    const storeParams = JSON.parse(JSON.stringify(searchParams));
    storeParams.offset = searchParams.offset.toString();
    storeParams.limit = searchParams.limit.toString();
    // call api function
    return api.getSignatories(storeParams)
      .then((response) => {
        if (response.status === 'success') {
          commit(types.SET_SIGNATORIES, response.data);
          return Promise.resolve(response.data);
        }
        return Promise.reject(response);
      })
      .catch((error) => {
        commit(types.RESET_SIGNATORIES);
        store.dispatch('application/displaySnackbar', {
          text: Vue.$i18n.t('store.signatory.get.error'),
          time: 3,
          type: 'error',
        });
        return Promise.reject(error);
      })
      .finally(() => {
        store.dispatch('application/finishLoading');
      });
  },
  resetSearchParams({ commit }) {
    commit(types.SET_SIGNATORY_SEARCH_PARAMS, {
      orders: [
        {
          fieldName: 'fullname',
          orderBy: 'ASC',
        },
      ],
      offset: 0,
      limit: 20,
    });
  },
  clear({ commit }) {
    store.dispatch('signatory/resetSearchParams');
    commit(types.RESET_SIGNATORIES);
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/signatory/actions.js